<template>
  <div class="bg-white height-100 w-full flex justify-center items-center">
    <div class="rounded-full pr-8">
      <img
        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/BA.png"
        alt=""
      />
    </div>

    <div class="pb-20">
      <h1 class="font-bold">
        Your website was <br />
        taken down
      </h1>
      <h5 class="my-4">
        Seems like you were inactive for quite some <br />
        time.
      </h5>
      <button
        class="bg-primary text-white fsize14 px-8 py-4 border-0 rounded-full"
      >
        Contact Support
      </button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
